import { IMedicalServiceEtlField } from 'interfaces';
import { BaseService } from './BaseService';
import { axiosPrivate } from 'services/axios';

class MedicalServiceEtlFieldService extends BaseService<IMedicalServiceEtlField> {
  constructor() {
    super('medical-service-etl-fields');
  }
  canBulkDelete = true;

  getChoices = async () => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/get-choices/`);
    return res;
  };
}

export const medicalServiceEtlFieldService = new MedicalServiceEtlFieldService();
